import { GetterTree } from 'vuex'
import { IRootState, IProductsState, IPlan } from '@/@types'
import CONSTANTS from '@/constants'

const getters: GetterTree<IProductsState, IRootState> = {
  plansByTerm: state => {
    return state.availablePlans.reduce(
      (
        acc: { yearly: Array<IPlan>; monthly: Array<IPlan>; quarterly: Array<IPlan> },
        plan: IPlan
      ) => {
        switch (plan.term) {
          case 'month':
            acc.monthly.push(plan)
            break
          case 'quarterly':
            acc.quarterly.push(plan)
            break
          default:
            acc.yearly.push(plan)
            break
        }
        return acc
      },
      { yearly: [], monthly: [], quarterly: [] }
    )
  },
}

export default getters
